import React from 'react';
import { Tag } from 'antd';
import CourseObj from '../objects/courseType';

const renderTag = (courseType) => {
  const typeText =
    String(courseType || '').trim() === 'LECTURE'
      ? 'MIN60'
      : String(courseType || '').trim();
  const target = CourseObj.courseType.find(
    (item) => item.type === typeText || item.name === typeText
  );

  return target ? (
    <Tag color={target.color}>{target.name}</Tag>
  ) : typeText ? (
    <Tag color='green'>{typeText}</Tag>
  ) : null;
};

const renderReminder = (text) => {
  return text ? <Tag color='orange'>{text}</Tag> : null;
};

const columns = [
  {
    title: '\u6b21\u6570',
    dataIndex: 'lessonIndex',
    key: 'lessonIndex',
    width: 80,
  },
  {
    title: '\u540d\u5b57',
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: '上课老师',
    dataIndex: 'teacherName',
    key: 'teacherName',
  },
  {
    title: '\u5185\u5bb9',
    dataIndex: 'content',
    key: 'content',
  },
  {
    title: '\u7c7b\u578b',
    dataIndex: 'courseType',
    key: 'courseType',
    render: (courseType) => renderTag(courseType),
  },
  {
    title: '\u65e5\u671f',
    dataIndex: 'date',
    key: 'date',
  },
  {
    title: '\u7ed3\u8bfe\u63d0\u9192',
    dataIndex: 'courseEndReminder',
    key: 'courseEndReminder',
    render: (text) => renderReminder(text),
  },
];

export default { columns };
